declare namespace $ {

	type $mol_string_button__hint_bog_blitz_admin_question_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_admin_question_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['question_text'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_paragraph__title_bog_blitz_admin_question_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['number_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select__value_bog_blitz_admin_question_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['question_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_bog_blitz_admin_question_5 = $mol_type_enforce<
		({ 
			'choice': string,
			'text_input': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_question_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_question_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_bog_blitz_admin_question_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_list__rows_bog_blitz_admin_question_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['option_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_question_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_question_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['add_option'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_string_button__hint_bog_blitz_admin_question_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_admin_question_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['correct_text'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_row__sub_bog_blitz_admin_question_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['image_section_content'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_open__title_bog_blitz_admin_question_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['title'] >
	>
	type $mol_button_open__files_bog_blitz_admin_question_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['question_image_files'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_image__uri_bog_blitz_admin_question_17 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['question_image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_question_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_question_19 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_question['remove_image'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_blitz_admin_question extends $mol_list {
		question_text( next?: string ): string
		Text_input( ): $mol_string_button
		number_title( ): string
		Number( ): $mol_paragraph
		question_type( next?: string ): string
		Type_select( ): $mol_select
		delete( next?: any ): any
		Delete( ): $mol_button_minor
		Header( ): $mol_row
		option_rows( ): readonly(any)[]
		Options_section( ): $mol_list
		add_option( next?: any ): any
		Add_option( ): $mol_button_minor
		correct_text( next?: string ): string
		Correct_text_input( ): $mol_string_button
		question_rows( ): readonly(any)[]
		image_section_content( ): readonly(any)[]
		question_image_files( next?: readonly(any)[] ): readonly(any)[]
		question_image_uri( ): string
		remove_image( next?: any ): any
		question( ): any
		number( ): number
		rows( ): ReturnType< $bog_blitz_admin_question['question_rows'] >
		Image_section( ): $mol_row
		Image_upload( ): $mol_button_open
		Image_preview( ): $mol_image
		Image_remove( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=question.view.tree.d.ts.map